var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoIs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f3fafe;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m59.86,1.19H0v57.63h1.24c19.25,0,38.5,0,57.76,0,.16,0,.33,0,.49,0,.35,0,.5-.18.5-.55,0-2.27,0-4.55,0-6.82,0-16.28,0-32.56,0-48.84,0-.46-.09-.92-.14-1.41ZM2.43,37.71c0-.16.13-.34.25-.47,3.23-3.42,6.48-6.84,9.72-10.27,2.07-2.19,4.12-4.4,6.18-6.6.15-.16.32-.3.53-.49.2.16.38.29.54.44,4.65,4.65,9.3,9.31,13.94,13.97.59.6,1.17,1.21,1.72,1.84.31.35.55.33.87.05,1.71-1.47,3.42-2.94,5.14-4.4.92-.78,1.84-1.56,2.83-2.4,4.34,3.8,7.89,8.38,12.34,12.33H2.42c0-1.39,0-2.7,0-4.01Zm55.08,18.6H2.45v-11.9h55.06v11.9Zm0-17.09c-4.38-4.53-8.68-8.99-12.97-13.44-2.87,2.45-5.66,4.82-8.42,7.18-5.69-5.64-11.26-11.17-16.87-16.73-5.58,5.83-11.13,11.63-16.67,17.43-.05-.03-.1-.05-.15-.08V3.66h55.09v35.56Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m44.34,8.26c-3.48.11-6.08,2.83-6.06,6.1.02,3.54,2.76,6.01,6.2,6.11,2.93.08,5.68-2.95,5.68-6.1.28-3.31-3.05-6.2-5.82-6.11Zm3.39,6.28c-.1,1.79-1.67,3.41-3.49,3.37-1.99-.03-3.64-1.89-3.45-3.59-.15-1.75,1.52-3.57,3.47-3.58,2.2,0,3.55,2.11,3.46,3.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoIs);
export default __webpack_public_path__ + "static/media/POIs.21535f64bb650119f079bc7fbde4b53c.svg";
export { ForwardRef as ReactComponent };